import { Colour } from './colour';

export class FamilyTree {
  public readonly id: string = `${this.physicalMaterial}-${this.colourId}`;

  public constructor(
    public designID: string,
    public physicalMaterial: string,
    public description: string,
    public colourId: string,
    public colourDescription: string,
    public infoCode: string,
    public colours?: Colour[]
  ) {}
}
